import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import Dashboard from "./pages/Dashboard/Dashboard";
import Editor from "./pages/Editor/Editor";
import MyVideos from "./pages/MyVideos/MyVideos";
import Signup from "./pages/Signup/Signup";
import Login from "./pages/Login/Login";
import NotFound from "./pages/NotFound/NotFound";
import Pricing from "./pages/Subscription/Pricing";
import Billing from "./pages/Subscription/Billing";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import UserManagement from "./pages/Admin/UserManagement";
import Profile from "./pages/Profile/Profile";
import Settings from "./pages/Settings/Settings";
import { authService } from "./services/auth.service";
import { NotificationProvider } from "./contexts/NotificationContext";

const AuthenticatedLayout = () => {
  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <NotificationProvider>
      <Outlet />
    </NotificationProvider>
  );
};

const PublicLayout = () => {
  const isAuthenticated = authService.isAuthenticated();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

const AdminLayout = () => {
  const isAuthenticated = authService.isAuthenticated();
  const userRole = localStorage.getItem('user_role');

  if (!isAuthenticated || userRole !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <NotificationProvider>
      <Outlet />
    </NotificationProvider>
  );
};

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route element={<PublicLayout />}>
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
        </Route>

        {/* Protected Routes */}
        <Route element={<AuthenticatedLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/my-videos" element={<MyVideos />} />
          <Route path="/editor/:projectId" element={<Editor />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/settings" element={<Settings />} />
        </Route>

        {/* Admin Routes */}
        <Route element={<AdminLayout />}>
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/users" element={<UserManagement />} />
        </Route>

        {/* Redirect root to dashboard */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
